import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import {toastr} from 'react-redux-toastr';
import TextBoxControl from '../Common/TextBoxControl';
import CheckBoxControl from '../Common/CheckBoxControl';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import Select from 'react-select';
import {SHORT_DATE_FORMAT} from '../../constants';

export const NewContract = (id) => {
  return {
    id,
    startDate: moment().format(SHORT_DATE_FORMAT),
    termMonths: 0,
    sequenceNumber: '',
    chargeType: 'None',
    rebateType: 'None',
    chargeFrequencyType: null,
    rebateFrequencyType: null,
    chargeAmount: null,
    rebateAmount: null,
    isActive: true,
    contractTypeId: null,
    locations: [],
  };
};

const SelectField = (props)=> {
  let {label, name, value, options, onChange, clearable, disabled} = props;
  let isDisabled = disabled === undefined ? false : disabled;
  return (
    <div className="form-group row">
      <label className="col-3 form-control-label" htmlFor={name}>{label}</label>
      <div className="col-9">
        <Select
          name={name}
          value={value}
          simpleValue
          options={options}
          onChange={(val) => onChange(name, val)}
          clearable={clearable}
          disabled={isDisabled}
        />
      </div>
    </div>
  );
};

class ContractView extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      contract: props.contract ? props.contract : NewContract(-1),
      isEdit: props.isEdit,
      rebateTypes: [{label: 'None', value: 'None'},{label: 'By Litre', value: 'By Litre'},{label: 'Annual', value: 'Annual'}],
      chargeTypes: [{label: 'None', value: 'None'},{label: 'One-off', value: 'One-off'},{label: 'By Litre', value: 'By Litre'},{label: 'Annual', value: 'Annual'}],
      rebateFrequencyTypes: [{label: 'Monthly', value: 'Monthly'},{label: 'Quarterly', value: 'Quarterly'},{label: 'Annually', value: 'Annually'}],
      chargeFrequencyTypes: [{label: 'One-off', value: 'One-off'},{label: 'Monthly', value: 'Monthly'},{label: 'Quarterly', value: 'Quarterly'},{label: 'Annually', value: 'Annually'}],
      contractTypes: [{label: "Collection", value: 1}, {label: "Fresh Oil", value: 2}]
    };

    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleSelectFieldChange = this.handleSelectFieldChange.bind(this);
    this.getCurrentState = this.getCurrentState.bind(this);
  }

  handleFieldChange(e){
    let x = {...this.state.contract};

    if(e.target.type==="checkbox"){
      x[`${e.target.name}`] = e.target.checked;
    }
    else if(e.target.type==='number') {
      let val = parseFloat(e.target.value.replace(/[^0-9.]/g,''));
      x[`${e.target.name}`] = val;
    }
    else {
      x[`${e.target.name}`] = e.target.value;
    }

    this.setState({contract: x});
  }

  handleSelectFieldChange(field, val) {
    let contract = {...this.state.contract};
    contract[field] = val;
    this.setState({contract});
  }

  handleSave(){
    let current = this.getCurrentState();
    if(current){
      if(current.chargeType === 'None'){
        current.chargeAmount = null;
        current.chargeFrequencyType = null;
      }
      if(current.rebateType === 'None'){
        current.rebateAmount = null;
        current.rebateFrequencyType = null;
      }
      this.props.onSave(current);
    } else {
      toastr.error('Please complete the contract form');
    }
  }

  handleCancel(){
    this.props.onCancel();
  }

  getCurrentState(){
    return {...this.state.contract};
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if(JSON.stringify(prevProps.contract) !== JSON.stringify(this.props.contract)){
      this.setState({contract: this.props.contract});
    }
  }

  componentDidMount() {
    let {location, contract} = this.props;

    if (location && location.id > 0 && contract.id === -1) {
      let locations = [...contract.locations, {id: location.id, locationName: location.locationName}];      
      this.setState({contract: {...contract, locations}});
    }
  }

  render(){
    let {contract} = this.state;
    let {isReadOnly} = this.props;

    if(!contract){
      return null;
    }

    let valid = ()=>{
      let messages = [];
      if(contract.startDate == ''){
        messages.push('Invalid start date');
      }

      if(contract.termMonths == '' || contract.termMonths <= 0){
        messages.push('Term months must be greater than 0');
      }

      if(contract.sequenceNumber == ''){
        messages.push('Please provide a contract number');
      }

      if(contract.chargeType !== 'None'){
        if(contract.chargeFrequencyType == null){
          messages.push('Please select a charge frequency');
        }
        if(contract.chargeAmount <= 0){
          messages.push('Please enter a charge amount greater than 0');
        }
      }

      if(contract.rebateType !== 'None'){
        if(contract.rebateFrequencyType == null){
          messages.push('Please select a rebate frequency');
        }
        if(contract.rebateAmount <= 0){
          messages.push('Please enter a rebate amount greater than 0');
        }
      }

      return {
        isValid: messages.length == 0,
        messages
      };
    };
    let v = valid();

    return (this.state.isEdit && contract && contract.id) ?
      (
        <div className="form-horizontal col-12">
          <div className="form-group row">
            <label className="col-3 form-control-label" htmlFor="startDate">Start Date</label>
            <div className="col-9">
              <DatePicker
                onChange={(val) => this.handleFieldChange({target: {name: 'startDate', value: val.format('YYYY-MM-DD')}})}
                className="form-control"
                value={moment(contract.startDate).format(SHORT_DATE_FORMAT)}
                openToDate={moment(contract.startDate)}
                placeholderText="Start date"
                locale="en-au"
                name="startDate"
                readOnly={isReadOnly}
              />
            </div>
          </div>

          <TextBoxControl
            name={'termMonths'}
            labelText={'Term (months)'}
            value={contract.termMonths ? contract.termMonths.toString() : ''}
            onChange={this.handleFieldChange}
            type="number"
            disabled={isReadOnly}
          />

          <TextBoxControl
            name={'expires'}
            labelText={'Expires'}
            value={moment(contract.startDate).add(contract.termMonths, 'months').format(SHORT_DATE_FORMAT)}
            onChange={()=>{}}
            disabled={true}
          />

          <TextBoxControl
            name={'sequenceNumber'}
            labelText={'Contract Number'}
            value={contract.sequenceNumber ? contract.sequenceNumber.toString() : ''}
            type="number"
            onChange={this.handleFieldChange}
            disabled={isReadOnly}
          />

          <SelectField
            label={'Charge Type'}
            name={'chargeType'}
            value={contract.chargeType}
            onChange={this.handleSelectFieldChange}
            options={this.state.chargeTypes}
            clearable={false}
            disabled={isReadOnly}
          />

          { contract.chargeType !== 'None' && <SelectField
            label={'Charge Frequency'}
            name={'chargeFrequencyType'}
            value={contract.chargeFrequencyType}
            onChange={this.handleSelectFieldChange}
            options={this.state.chargeFrequencyTypes}
            clearable
            disabled={isReadOnly}
          /> }

          { contract.chargeType !== 'None' && <TextBoxControl
            name={'chargeAmount'}
            labelText={'Charge Amount'}
            value={contract.chargeAmount == null ? '' : contract.chargeAmount}
            onChange={this.handleFieldChange}
            type="number"
            step={'any'}
            disabled={isReadOnly}
          />}

          <SelectField
            label={'Rebate Type'}
            name={'rebateType'}
            value={contract.rebateType}
            onChange={this.handleSelectFieldChange}
            options={this.state.rebateTypes}
            clearable={false}
            disabled={isReadOnly}
          />

          { contract.rebateType !== 'None' && <SelectField
            label={'Rebate Frequency'}
            name={'rebateFrequencyType'}
            value={contract.rebateFrequencyType}
            onChange={this.handleSelectFieldChange}
            options={this.state.rebateFrequencyTypes}
            clearable
            disabled={isReadOnly}
          />}

          { contract.rebateType != 'None' && !isReadOnly && <TextBoxControl
            name={'rebateAmount'}
            labelText={'Rebate Amount'}
            value={contract.rebateAmount == null ? '' : contract.rebateAmount}
            onChange={this.handleFieldChange}
            type="number"
            step={'any'}
            disabled={isReadOnly}
          />}

          <SelectField
            label={'Contract Type'}
            name={'contractTypeId'}
            value={contract.contractTypeId}
            onChange={this.handleSelectFieldChange}
            options={this.state.contractTypes}
            clearable={false}
            disabled={isReadOnly}
          />

          <CheckBoxControl
            name={'isActive'}
            labelText={'Is Active'}
            value={contract.isActive}
            onChange={this.handleFieldChange}
            disabled={isReadOnly}
          />

          { !isReadOnly && <h6>Contract Applies to Locations <a href="#" onClick={(e)=>{
            e.preventDefault();
            this.setState({contract: {...contract, locations: this.props.locations}});
          }}>Select All</a>/<a href="#" onClick={(e)=>{
            e.preventDefault();
            this.setState({contract: {...contract, locations: []}});
          }}>Deselect All</a></h6> }

          {(contract && contract.locations) && this.props.locations.map(l => {
            let foundIndex = contract.locations.findIndex(x => x.id===l.id);

            return (
              <CheckBoxControl
                disabled={isReadOnly}
                key={l.id}
                name={l.id}
                labelText={l.locationName}
                value={foundIndex >= 0}
                onChange={(e) => {
                  let locations = [...contract.locations];
                  let val = e.target.checked;
                  if(val){
                    locations = [...locations, {id: l.id, locationName: l.locationName}];
                  } else {
                    locations = locations.filter(x => x.id!==l.id);
                  }
                  this.setState({contract: {...contract, locations}});
                }}
              />);
          })}

          <div className="form-group row">&nbsp;</div>

          { !v.isValid && <div className="form-group row">
            {v.messages.map((x,i) => {
              return (<div className="alert alert-danger offset-3 col-9" role="alert" key={`val-${i}`}>{x}</div>);
            })}
          </div>}


          {(this.props.onSave) &&
          <div className="form-group row">
            {(v.isValid && !isReadOnly) && <Button color="success" onClick={this.handleSave} style={{marginRight: '10px'}}><i className="fa fa-save" />&nbsp;&nbsp;Save</Button>}
              <Button color="danger" onClick={this.handleCancel}><i className="fa fa-times" />&nbsp;&nbsp;Cancel</Button>
          </div> }

        </div>

      )
      :
      (<div>View mode really</div>);
  }
}

ContractView.propTypes = {
  contract: PropTypes.object.isRequired,
  location: PropTypes.object,
  locations: PropTypes.array.isRequired,
  onContractUpdated: PropTypes.func,
  isEdit: PropTypes.bool,
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
  isReadOnly: PropTypes.bool.isRequired
};

ContractView.defatultProps = {
  isEdit: true,
};

export default ContractView;